<isophi-app-portfolio-plan-base-item #base *transloco="let t" [leftIcon]="'info'" [title]="title" [allowEditMode]="allowEditMode">
  <div *ngIf="base.isViewMode() && !!control.value" class="desc-text">{{ control.value }}</div>
  <div *ngIf="allowEditMode && base.isEditMode()">
    <textarea
      class="custom-textarea description-textarea mb-2"
      [placeholder]="t('planDetail/description')"
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      [formControl]="control"
    ></textarea>

    <div class="actions d-flex justify-content-end">
      <button (click)="cancel(); base.setMode(base.modeEnum.VIEW)" class="btn btn-light-outline">
        {{ t('common/cancel') }}
      </button>

      <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
        {{ t('common/save') }}
      </button>
    </div>
  </div>
</isophi-app-portfolio-plan-base-item>
